var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 3.83333L6.99935 5L9.16602 7.16667H0.666016V8.83333H9.16602L6.99935 11L8.16602 12.1667L12.3327 8L8.16602 3.83333ZM15.666 13.8333H8.99935V15.5H15.666C16.5827 15.5 17.3327 14.75 17.3327 13.8333V2.16667C17.3327 1.25 16.5827 0.5 15.666 0.5H8.99935V2.16667H15.666V13.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/SignIn.6bdfd2a05d5fc05ecfbcee25d97ba284.svg";
export { ForwardRef as ReactComponent };